<script setup lang="ts">
/**
 * Приоритет — макет 5:21: один знак в поле 16, цветом приоритета. Восклицание
 * наивысшему, стрелка вверх высокому, равно среднему, стрелка вниз низкому.
 *
 * Средний приоритет виден так же, как остальные: он стоит у большинства задач
 * по умолчанию, и прятать его значит оставить в футере дыру, из-за которой
 * соседние карточки перестают читаться одинаково.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { V1Priority } from '@/api/clients/tracker-issue'

import { priorityVisual } from '../visuals'

const props = defineProps<{ priority: V1Priority | '' }>()

const { t, te } = useI18n()

const visual = computed(() => priorityVisual(props.priority))

const label = computed(() =>
  props.priority && te(`issues.priorities.${props.priority}`)
    ? t(`issues.priorities.${props.priority}`)
    : '',
)
</script>

<template>
  <span v-if="visual" class="prio" :style="{ color: visual.color }" :title="label">
    <span aria-hidden="true">{{ visual.glyph }}</span>
    <span class="prio__label">{{ label }}</span>
  </span>
</template>

<style scoped>
.prio {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-bold);
  line-height: 1;
}

.prio__label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
</style>
